Object.defineProperty(exports, "__esModule", {
  value: true
});

var ESTransport = function () {
  function ESTransport() {}

  return ESTransport;
}();

exports.ESTransport = ESTransport;